const pannes = [
  "Volet bloqué en position ouverte, fermée ou entre deux",
  "Volet qui ne remonte plus malgré la manivelle ou la télécommande",
  "Volet qui ne descend plus et reste coincé en haut",
  "Tablier sorti des glissières ou lame bloquée dans les rails",
  "Moteur silencieux ou qui ne répond plus au point de commande",
  "Télécommande Somfy, Nice ou Simu sans réaction",
  "Bruits anormaux : grincements, cliquetis ou vibrations fortes",
  "Sangle cassée ou cordon usé empêchant le mouvement",
  "Fin de course déréglée après une surcharge ou une manipulation brutale",
];

export default function PannesUrgence() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-3">
          Les pannes que nous dépannons en urgence
        </h2>
        <p className="text-brand-text text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Quel que soit le symptôme, nos techniciens diagnostiquent la panne et réparent sur place quand cela est possible.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {pannes.map((panne) => (
            <div key={panne} className="flex items-start gap-3 bg-white rounded-xl border border-brand-border p-4 md:p-5">
              <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-check-line text-brand-cyan text-lg"></i>
              </div>
              <p className="text-brand-text text-sm leading-relaxed">{panne}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}